module.exports = __webpack_public_path__ + "img/illustration.04876e8b.png";